export class ClosePageActivity {
  constructor({router}, {PageId}) {
    this.pageId  = PageId
    this.$router = router
  }

  run() {
    this.$router.go(-1)
    
  }
}